import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export const Container = ({ grid960, children }) => (
  <div className={`${midas.container} ${grid960 ? midas.grid960 : ''}`}>
    {children}
  </div>
)

Container.propTypes = {
  grid960: PropTypes.bool,
  children: PropTypes.any.isRequired,
}

Container.defaultProps = {
  grid960: null,
}
